import React, { Component } from 'react';
import { connect } from 'react-redux';
import moize from 'moize';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import { Grid, Col } from '@bit/knotchinc.web-react-components.grid';
import { ContentTimeSeriesTile } from 'components/Tiles/';
import { SectionTitle } from 'components/Global/Title/Title.jsx';
import Mixpanel from 'helpers/Mixpanel.js';
import InsightsBrandLogos from '../InsightsBrandLogos.jsx';
import TotalContentBreakdownRow from './TotalContentBreakdownRow.jsx';
import ContentStatsRow from './ContentStatsRow.jsx';

class ContentInsightsTab extends Component {
  constructor() {
    super();
    this.memoFetchMap = moize.deep((metadata, fetch) => this.generateFetchMap(metadata, fetch));
  }

  componentDidMount() {
    Mixpanel.track(`view Insights: content tab`);
  }

  generateFetchMap(metadata, fetch) {
    return Object.keys(metadata).reduce((fetchMap, entityId) => {
      fetchMap[entityId] = () => fetch(entityId);
      return fetchMap;
    }, {});
  }

  render() {
    const { content, metadata, entities, fetchData, owned } = this.props;
    const fetchMap = this.memoFetchMap(metadata, id => fetchData(id));

    return (
      <StoreSync stores={content} fetchMap={fetchMap}>
        <InsightsBrandLogos metadata={metadata} />
        <TotalContentBreakdownRow owned={owned} metadata={metadata} content={content} />
        <Grid height={437}>
          <Col centered>
            <SectionTitle>Content Over Time</SectionTitle>
            <ContentTimeSeriesTile entities={entities} content={content} />
          </Col>
        </Grid>
        <ContentStatsRow entitiesList={entities} content={content} />
      </StoreSync>
    );
  }
}

const mapStateToProps = ({ Insights: { content, metadata } }) => ({
  content,
  metadata,
  entities: Object.values(metadata),
});


export default connect(mapStateToProps)(ContentInsightsTab);
